import Loader from "Components/Loader";
import React, { useEffect, useState } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { connect } from "react-redux";
import utils from "utils";
import api from "utils/api";
import NewClinician from "./NewClinician";
// import "./Billing.scss";
function EditClinician(props) {
  const [loader, setLoading] = useState(true);
  const [editData, setEditData] = useState({});
  const [formActionState, formAction] = useState(false);
  const location = useLocation();
  const history = useHistory();
  
  const doctor_id = location.state?.doctor_id;

  function fetchClinicianDetails() {
    // const doctor_id = location.state?.doctor_id;
    // if (!doctor_id) {
    //   history.push(`${props.user_details.baseUrl}/clinician`);
    // } else {
    const query = new URLSearchParams({
      doctor_id: doctor_id,
    }).toString();
    api
      .get_edit_doctor_details(query)
      .then((response) => {
        if (response.data.status === 200) {
          const result = response.data.data.results[0];
          setEditData(result);
        } else {
          message.error(response.data.status);
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        setLoading(false);
      });
    // }
  }
  useEffect(() => {
    fetchClinicianDetails();
  }, []);
  return (
    <div className="billing">
      {loader ? (
        <Loader />
      ) : (
        <>
          <div
            onClick={() => {
              history.push(`${props.user_details.baseUrl}/clinician`);
            }}
            className="previous-page-button"
          >{`< Back To Previous Page`}</div>
          {editData && (
            <NewClinician
              formAction={formAction}
              editData={editData}
              doctor_id={doctor_id}
              submitButtonAction={() => {
                history.push(`${props.user_details.baseUrl}/clinician`);
              }}
            />
          )}
        </>
      )}
    </div>
  );
}
const mapStateToProps = (state) => {
  return {
    user_details: state.loginReducer?.user_details,
  };
};
const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(EditClinician);
